module.exports = __webpack_public_path__ + "img/zucchini-847094.dbb5c38e.jpg";